import { render, staticRenderFns } from "./ComplaintsChatModal.vue?vue&type=template&id=5780cb56&scoped=true"
import script from "./ComplaintsChatModal.vue?vue&type=script&lang=js"
export * from "./ComplaintsChatModal.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsChatModal.vue?vue&type=style&index=0&id=5780cb56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5780cb56",
  null
  
)

export default component.exports